module.exports = __webpack_public_path__ + "img/other-red.059f3c4c.png";